var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83341 3.33341V7.64306L12.1667 15.9764L16.4764 11.6667L8.14306 3.33341L3.83341 3.33341ZM2.16675 3.33341V7.64306C2.16675 8.08509 2.34234 8.50901 2.6549 8.82157L10.9882 17.1549C11.6391 17.8058 12.6944 17.8058 13.3453 17.1549L17.6549 12.8453C18.3058 12.1944 18.3058 11.1391 17.6549 10.4882L9.32157 2.1549C9.00901 1.84234 8.58509 1.66675 8.14306 1.66675H3.83341C2.91294 1.66675 2.16675 2.41294 2.16675 3.33341Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.83342 6.25008C8.83342 7.40067 7.90067 8.33342 6.75008 8.33342C5.59949 8.33342 4.66675 7.40067 4.66675 6.25008C4.66675 5.09949 5.59949 4.16675 6.75008 4.16675C7.90067 4.16675 8.83342 5.09949 8.83342 6.25008Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.dd55bbfd722816d9de0ee29cc989d602.svg";
export { ForwardRef as ReactComponent };